export default {
  en: {
    inviteModal: {
      title: 'Invite a sub-entity',
      description: 'Invite a sub-entity to join your federated group.',
      inviteButton: 'Invite sub-entity',
      cancel: 'Cancel',
      sendInvite: 'Send invite',
      companyNamePlaceholder: 'Enter a company name...',
      emailPlaceholder: 'Enter a contact email...',
      companyName: 'Company name',
      email: 'Contact email',
      nameRequireError: 'Please enter a company name.',
      emailRequireError: 'Please enter a contact email.',
      emailValidError: 'Please enter a valid contact email.',
      errorInviting: 'Failed sending sub-entity invite. Please try again.',
      inviteSentTitle: 'Invite sent',
      inviteSentDescription:
        "Your invite to {email} at {name} has been sent. We'll let you know once they have signed up.",
      inviteMore: 'Invite more',
    },
    acceptModal: {
      title: {
        pending: 'Accept invite',
        expired: 'Invite expired',
        cancelled: 'Invite cancelled',
        accepted: 'Invite already accepted',
      },
      description: {
        pending:
          '{user} from {org} is inviting you to join their federated group on Risk Ledger. Would you like to join? You can always decide later by clicking your invite link again.',
        expired:
          '{user} from {org} invited you to join their federated group on Risk Ledger. The invite has expired, but you can still join by contacting them or Risk Ledger support.',
        cancelled:
          '{user} from {org} invited you to join their federated group on Risk Ledger. The invite was cancelled, but if you think this is a mistake then contact them or Risk Ledger support.',
        accepted:
          "{user} from {org} invited you to join their federated group on Risk Ledger. The invite has already been accepted; if you're not already connected then you can still join by contacting them or Risk Ledger support.",
      },
      accept: 'Accept invite',
      later: 'Later',
      close: 'Close',
      fetchFailed: 'Failed to get invite information. Try again or contact Risk Ledger support.',
      tryAgain: 'Try again',
      acceptFailed: 'Failed to accept invite. Try again or contact Risk Ledger support.',
      inviteAccepted: 'Invite accepted.',
    },
    invitePanel: {
      yourInvites: 'Your invites',
      close: 'Close',
      cancel: 'Cancel',
      sentBy: 'Sent by {name} on {date}',
      expired: 'Expired on {date}',
      pending: 'Expires on {date}',
      cancelled: 'Cancelled on {date}',
      confirm: 'Confirm',
      cancelTitle: 'Cancel invite',
      cancelDescription: 'Are you sure you want to cancel the federated invite to {name}?',
      errorCancelling: 'There was an error cancelling the invite. Please try again.',
      export: 'Export',
      name: 'Name',
      email: 'Email',
      expiry: 'Expiry',
    },
    filters: {
      pending: 'Pending',
      expired: 'Expired',
      cancelled: 'Cancelled',
      pendingWithCount: '{num} pending',
      expiredWithCount: '{num} expired',
      cancelledWithCount: '{num} cancelled',
    },
    placeholders: {
      emptyTitle: 'Your invites',
      emptyDescription: "We couldn't find any matching invites.",
      errorTitle: 'Your invites',
      errorDescription: 'Failed fetching your invites.',
    },
  },
};
